import { FormProvider } from 'react-hook-form';

import { IconButton, SlideOut, SlideOutControls } from '@hsp/react-component-library';

import { useFilterConfiguration } from '@p/security/users/dashboard/component/slideout/filter/hooks/configuration.hook';
import { useCreateUserFilterForm } from '@p/security/users/dashboard/component/slideout/filter/hooks/form/create.form';
import UserFilterBody from '@p/security/users/dashboard/component/slideout/filter/slideout-body/body.component';

import { s } from '@u/strings';

const UserFilterSlideOut = () => {
  const { isOpenFilter, setIsOpenFilter, handleSubmitted } = useFilterConfiguration();
  const methods = useCreateUserFilterForm();
  const { handleSubmit } = methods;

  return (
    <>
      <FormProvider {...methods}>
        <SlideOut
          isOpen={isOpenFilter}
          onClosed={() => {
            setIsOpenFilter(false);
            methods.reset();
          }}
          showFooter
          title="Filter">
          <form
            id="frm-filter-userDashboard"
            onSubmit={handleSubmit((formData) => handleSubmitted(formData))}>
            <UserFilterBody />
          </form>
          <SlideOutControls>
            <IconButton
              color="primary"
              form="frm-filter-userDashboard"
              icon={'save'}
              type="submit">
              {s('Site.Apply')}
            </IconButton>
          </SlideOutControls>
        </SlideOut>
      </FormProvider>
    </>
  );
};

export default UserFilterSlideOut;
